import React, { useState } from 'react';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { usePHSPACCCompetenceCurationCompany } from '@components/phs/pacc/results/query/useCompetence';
import BarChart from './barChart';
import CompanyCulture from './companyCulture';
import CompetencyInnerCard from '../common/competencyInnerCard';
import CompetencyCard from '../common/competencyCard';
import { cultureCardData } from '@domain/constant/companyType';
import classnames from 'classnames/bind';
import styles from './companyRecommend.module.scss';

const cx = classnames.bind(styles);

const barChartTooltipContent = (
  <>
    <p>
      잡다에서 제공하는 15가지 기업문화와 역량검사에서 분석한 응시자님의 특성을 바탕으로 응시자님과 가장 잘 맞는
      기업문화를 추천해드려요.
    </p>
  </>
);

interface CompanyRecommendProps {
  sn: number;
}

const CompanyRecommend = ({ sn }: CompanyRecommendProps) => {
  const [barChartsVisible, setBarChartsVisible] = useState(false);
  const { data: useInfo } = useUserInfo();
  const { data: paccCompanyCurationResult } = usePHSPACCCompetenceCurationCompany(sn);
  const userName = useInfo?.name ?? '';

  if (!paccCompanyCurationResult) return null;

  const { scores, themes } = paccCompanyCurationResult;

  const barChartData = () => {
    return scores?.map((accCompanyCurationScore) => {
      const { type, score } = accCompanyCurationScore;
      const title = cultureCardData[type].title;
      const emphasized = themes?.some((companyCurationTheme) => {
        return companyCurationTheme.type === type;
      });
      return { title: title, value: score, emphasized: emphasized };
    });
  };

  return (
    <CompetencyCard title={`${userName}님에게 잘 어울리는 기업 추천`} cardType={'gray'} iconType={'company'}>
      <div className={cx('wrap')}>
        <CompetencyInnerCard title={'나에게 잘맞는 기업 문화는?'} tooltipContent={barChartTooltipContent}>
          {/* [D] 기업 문화 영역 */}
          <CompanyCulture paccCompanyCurationResult={paccCompanyCurationResult} />

          {/* [D] 바차트 영역 */}
          <div className={cx('barChartWrap')}>
            <a
              className={cx('barChartBtn', { open: barChartsVisible })}
              onClick={() => setBarChartsVisible(!barChartsVisible)}
              role="button"
            >
              {barChartsVisible ? '접어두기' : '기업문화별 적합도 확인하기'}
            </a>
            <div
              style={{
                overflow: 'hidden',
                height: !barChartsVisible ? '0px' : '585px',
                transition: barChartsVisible ? '.5s all ease-in-out' : '',
              }}
            >
              <div className={cx('barChartContents')}>
                <BarChart data={barChartData()} interactionTrigger={barChartsVisible} />
              </div>
            </div>
          </div>
        </CompetencyInnerCard>
      </div>
    </CompetencyCard>
  );
};

export default CompanyRecommend;
